var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-profile'),_c('div',{staticClass:"container-profile pb-5"},[_c('profile-change-password')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }